module.exports = __webpack_public_path__ + "static/media/hot-gatget.264c6831.jpg";